<template>
    <div id="app">
        <img src="http://shared.youdao.com/dict/market/oxford-activity/imgs/masterBanner.png" alt="" class="banner">
        <get-code v-bind:isCanGet="isCanGet" v-bind:signId="signId" class="main"/>
        <geted-number v-bind:list="data"/>
        <rule class="rule"/>
    </div>
</template>

<script>
    import GetCode from './components/GetCode';
    import GetedNumber from './components/GetedNumber';
    import Rule from './components/Rule'
    import { getParameter, initShareData } from './libs/util.js'
    import jsonp from 'jsonp'
    import axios from 'axios';
    export default {
        name: 'app',
        data () {
            return {
                data: '',
                signId: '',
                isCanGet: ''
            }
        },
        created () {
            let that = this
            initShareData( window.location.href, true)
            that.signId = getParameter('signId')
            let url = `http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/showDictVIP?signId=${that.signId}`
            jsonp(url, function (err, data) {
                if (data.code != 403) {
                    that.data = data.result.friendInfoList
                    that.isCanGet = data.result.halfYear
                }
                
            })
        },
        components: {
            GetCode,
            GetedNumber,
            Rule
        }
    }
</script>

<style>
    #app {
        overflow: hidden;
    }
    img {
        display: block;
    }
    .rule {
        margin: -1.5rem auto 0.86rem !important;
    }
    .banner {
        width: 100%;
        height: 19.17rem;
    }
    .main {
        margin-top: -1.5rem;
    }

    
</style>



// WEBPACK FOOTER //
// App.vue?6e2f2de5